// import { Text } from "../Text"; // No longer needed here
import clsx from "clsx";
import { Slot as SlotPrimitive } from "radix-ui";
import React from "react";
import styles from "./button.module.scss";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "destructive";
  size?: "small" | "medium" | "large";
  fullWidth?: boolean;
  loading?: boolean;
  asChild?: boolean;
  children?: React.ReactNode;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      size = "medium",
      fullWidth = false,
      loading = false,
      asChild = false,
      children,
      className,
      disabled,
      ...props
    },
    ref
  ) => {
    const buttonClass = clsx(
      styles.button,
      styles[variant],
      styles[size],
      {
        [styles["full-width"]]: fullWidth,
        [styles.iconOnly]:
          !children || (typeof children === "string" && children.trim() === ""),
      },
      className
    );

    const isDisabled = disabled || loading;

    // Render Slot if asChild is true, otherwise render a button element
    return asChild ? (
      <SlotPrimitive.Slot
        className={buttonClass}
        ref={ref}
        data-loading={loading}
        {...props}
      >
        {children}
      </SlotPrimitive.Slot>
    ) : (
      <button
        className={buttonClass}
        ref={ref}
        disabled={isDisabled}
        data-loading={loading}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";
